module.exports = __webpack_public_path__ + "img/zacros.88c7c3f2.jpg";